<template>
  <table class="Table">
    <thead class="Table__head">
      <tr class="TableHead__row" v-if="head">
        <th class="TableHead__col" v-for="item in head">{{item}}</th>
      </tr>
      <slot name="thead"></slot>
    </thead>
    <tbody class="Table__body">
      <slot></slot>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    head: Array
  },
}
</script>

<style lang="stylus" src="./style.styl"></style>
